import { AutogenModelTrackingProvider, AutogenRowTrackingProvider } from "./autogen/AutogenModelTrackingProvider";

export class ModelTrackingProvider extends AutogenModelTrackingProvider<RowTrackingProvider> {
	constructor() {
		super(RowTrackingProvider);
	}
}

export class RowTrackingProvider extends AutogenRowTrackingProvider {
}